import { useAtomValue } from 'jotai';
import { ReactNode } from 'react';

import { useAlchemySetupEffect } from '@creditornot/alchemy-react';
import { CookbookProvider } from '@creditornot/cb-provider';
import { themeModeAtom } from 'common/state/themeState';

type Props = {
  children: ReactNode;
};

export const ThemeProvider = ({ children }: Props) => {
  const themeMode = useAtomValue(themeModeAtom);

  useAlchemySetupEffect({ themeMode });

  return <CookbookProvider themeMode={themeMode}>{children}</CookbookProvider>;
};
